import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OrderItem } from 'graphql-api/baskets-api-interfaces';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { OrderHeader } from '../../models';
import { OrderGQL } from '../../queries/order-book-order.gql';
import { ORDERS_API_TOKEN } from '../../tokens';

@Injectable()
export class OrderDetailsService {
  constructor(
    private orderGQL: OrderGQL,
    private httpClient: HttpClient,
    @Inject(ORDERS_API_TOKEN) private url: string,
  ) {}

  public getOrderItems(
    orderNumber: string,
    accountIds?: string[],
  ): Observable<OrderItem[]> {
    return this.orderGQL
      .fetch({
        orderNumber,
        accountIds,
      })
      .pipe(
        take(1),
        map((queryResult) => (queryResult.data.order as OrderItem[]) ?? []),
      );
  }

  public getOrderHeader(
    salesOrderNumber: string,
    accountId: string,
    secondaryAccount: string | null,
  ): Observable<OrderHeader> {
    return this.httpClient.get<OrderHeader>(
      `${
        this.url
      }/${accountId}/order-header?salesOrderNumber=${salesOrderNumber}&accountId=${
        secondaryAccount || accountId
      }`,
    );
  }
}
